module.exports = __webpack_public_path__ + "static/media/Youtube.86bebd41.png";